import { useContext, useMemo } from 'react';
import ActionTypes from '@utils/deviceActions';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { useTranslation } from 'react-i18next';
import { IDevice } from '@pages/Assets/Inventory/types';
import rolesConstants from '@utils/rolesConstants';
import KeycloakContext from '@providers/Keycloak/KeycloakContext';

interface BaitRenewalPayloadProps {
  action: ActionTypes.BAIT_RENEWAL;
  devices: {
    msisdn: string;
  }[];
}

interface BaitRenewalProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useBaitRenewal = ({
  devices,
  isUpload,
}: BaitRenewalProps): DeviceActionProps => {
  const { t } = useTranslation('device-actions');
  const { keycloak } = useContext(KeycloakContext);
  const customerType = keycloak.idTokenParsed?.customerType;
  const isBroker = customerType === 'BROKER';

  const payloadToSend = useMemo(
    (): BaitRenewalPayloadProps => ({
      action: ActionTypes.BAIT_RENEWAL,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
    title: t(
      `labels.mot.${rolesConstants.BAIT_RENEWAL}${isBroker ? '-broker' : ''}`,
    ),
  };
};

export default useBaitRenewal;
